import { IGrant, ISolicitation } from '../../../types/Grants'
import { IPagingResponse } from '../../../types/Requests'
import moment from 'moment/moment'
import { convertPhase } from '../../../utils'

//shared types across slices, selectors and requests
interface GrantsFilters {
  agencies: string[]
  phases: string[]
  statuses: string[]
  dates: {
    startDate: moment.Moment | null
    endDate: moment.Moment | null
  }
}

export interface InitialState {
  data: IGrant[]
  paging: IPagingResponse
  filters: GrantsFilters
  loading: boolean
  error: string
}


//shared data
const defaultAgency = {
  title: 'N/A',
  acronym: 'N/A',
  backgroundColor: '#e0e0e0',
  textColor: '#424242',
}


//shared functions
export const normalizeGrants = (grants: IGrant[]) => {
  return grants.map((grant) => {
    const {
      awards_phaseI = '',
      awards_phaseII = '',
      topic_title = '',
      subtopic_title = '',
      solicitation = {},
      agency = defaultAgency
    } = grant

    const {
      type = [],
      close_date = '',
      solicitation_title: solicitationTitle = 'N/A',
      solicitation_number: solicitationNumber = '',
      phase: grantPhase = '',
    } = solicitation as ISolicitation

    const grantType = type.includes('federal') ? 'Federal opportunities' : 'Small business'

    const dueDate = close_date ? moment.utc(close_date).format('MMMM DD, YYYY') : 'N/A'
    const phaseValue = convertPhase(grantPhase)

    const awardsPhaseI =
      awards_phaseI === 'none' || awards_phaseI === '' ? 0 : parseInt(awards_phaseI, 10)
    const awardsPhaseII =
      awards_phaseII === 'none' || awards_phaseII === '' ? 0 : parseInt(awards_phaseII, 10)

    const totalAmount = awardsPhaseI + awardsPhaseII

    const formattedAmount = totalAmount.toLocaleString('en-US')

    return {
      ...grant,
      type,
      grantType,
      solicitationTitle: solicitationTitle,
      agency: agency,
      dueDate: dueDate,
      phase: phaseValue,
      solicitationNumber: solicitationNumber,
      grantId: grant.topicId || '',
      grantTitle: subtopic_title || topic_title,
      totalAmount,
      formattedAmount,
    }
  })
}